export default {"src":"/_next/static/image/public/images/error_book_phone.093cd9142ebd43d0ba48157c951430bf.svg","height":24,"width":24};